import {gql} from "@apollo/client";

export const GET_FILESZIPPED_PRESIGNED_URL = gql`
	query FilesZippedPresignedUrl($id: Int! )
	{
	   filesZippedPresignedUrl(input: {jobRunId :$id}) { url, contentType }
	}
`;
